import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';

import theme from '../../muiTheme';

const styles = {
    errorDialogContent: {
        width: "700px"
    },
    errorDialogTitle: {
        color: theme.palette.accent1Color
    }
}

class UserLayerDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            layerTitle: null,
            layerUrl: null,
            showByDefault: false,
            enablePopups: false,
        };
    }

    saveChanges = () => 
    {
        this.props.onSave(this.state.layerTitle, this.state.layerUrl, this.state.showByDefault, this.state.enablePopups);
    }

    updateLayerTitle = (title) => {
        this.setState({
            layerTitle: title
        });
    }

    updateLayerUrl = (url) => {
        this.setState({
            layerUrl: url
        });
    }

    handleShowByDefault = (event) => {
        const showByDefault = (event.target.checked);
        this.setState({
            showByDefault: showByDefault
        });
    }

    handleEnablePopups = (event) => {
        const enablePopups = (event.target.checked);
        this.setState({
            enablePopups: enablePopups
        });
    }

    render() {

        return (!this.props.open) ? "" : (
            <Dialog
                title="Add Layer"
                modal={true}
                open={this.props.open}
                contentStyle={styles.errorDialogContent}
                titleStyle={styles.errorDialogTitle}>
                
                <br />
                <Table aria-label="simple table">
                    <TableBody>
                        <TableRow>
                            <TableCell>Layer Title:</TableCell>
                            <TableCell align="right">
                                <TextField
                                    style={{ width: "500px" }}
                                    value={this.state.layerTitle}
                                    onChange={(e) => this.updateLayerTitle(e.target.value)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Layer URL:</TableCell>
                            <TableCell align="right">
                                 <TextField
                                    style={{ width: "500px" }}
                                    value={this.state.layerUrl}
                                    onChange={(e) => this.updateLayerUrl(e.target.value)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Show Layer by default:</TableCell>
                            <TableCell align="left">
                            <Checkbox
                                checked={this.state.showByDefault}
                                onChange={this.handleShowByDefault}
                            />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Enable popups:</TableCell>
                            <TableCell align="left">
                            <Checkbox
                                checked={this.state.enablePopups}
                                onChange={this.handleEnablePopups}
                            />
                            </TableCell>
                        </TableRow>
                      
                    </TableBody>
                </Table>
                <DialogActions>
                    <Button onClick={ (e) => this.saveChanges() } color="primary">
                        Add Layer
                    </Button>
                    <Button onClick={this.props.onClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default UserLayerDialog;
